
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import CalendarViewWeekOutlinedIcon from '@mui/icons-material/CalendarViewWeekOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import InputIcon from '@mui/icons-material/Input';

// export const settingsWarehouseWebshopConfig = {
//     all:  {
//         title: 'direct',
//         subtitle: 'saleschannels',
//         icon: <Inventory2OutlinedIcon/>,
//         isSingleDataGrid: true,
//     },
//     concept:  {
//         title: 'concept',
//         subtitle: 'saleschannels',
//         icon: <Inventory2OutlinedIcon/>,
//         isSingleDataGrid: true,
//     },
//     inactive:  {
//         title: 'inactive',
//         subtitle: 'saleschannels',
//         icon: <Inventory2OutlinedIcon/>,
//         isSingleDataGrid: true,
//     },
//     integrator: {
//         title: 'integrator',
//         subtitle: 'saleschannels',
//         icon: <Inventory2OutlinedIcon/>,
//         isSingleDataGrid: true,
//     }
// };

export const settingsWarehouseWebshopConfig = (totals) => {
    return {
        all:  {
            title: 'direct',
            subtitle: 'saleschannels',
            icon: <Inventory2OutlinedIcon/>,
            isSingleDataGrid: true,
            ...(totals && {count: totals.active})
        },
        concept:  {
            title: 'concept',
            subtitle: 'saleschannels',
            icon: <Inventory2OutlinedIcon/>,
            isSingleDataGrid: true,
            ...(totals && {count: totals.concept})
        },
        inactive:  {
            title: 'inactive',
            subtitle: 'saleschannels',
            icon: <Inventory2OutlinedIcon/>,
            isSingleDataGrid: true,
            ...(totals && {count: totals.inactive})
        },
        integrator: {
            title: 'integrator',
            subtitle: 'saleschannels',
            icon: <Inventory2OutlinedIcon/>,
            isSingleDataGrid: true,
        },

    };
};

